// Evaluation 분포·비교 차트에서만 쓰는 데이터 라벨과 이상치 표현이다.
// 라벨은 c6 muted 잉크를 그대로 쓴다. 이상치의 연한 빨강은 c6 에 대응 토큰이 없어 앱이 소유한다.
// status.error 를 쓰면 실패 계열과 세기가 같아져 이상치가 실제보다 강하게 읽힌다.
export const CHART_LABEL = "var(--c6-color-text-muted)";
export const CHART_OUTLIER = "#f87171";
